import type { RouteRecordRaw } from 'vue-router'
import { AppModule } from '@/config/types'
import { EmailLookupRoutes } from '@/routes/user/lookup/types'
import { getEmailLookupDetailsRoutes } from '@/routes/user/lookup/emailLookupDetails'

export const getEmailLookupRoutes = (): RouteRecordRaw[] => [
  {
    name: EmailLookupRoutes.index,
    path: 'email-lookup',
    meta: {
      permission: 'emailLookup',
      modules: [AppModule.EmailLookup, AppModule.EmailLookupSession],
    },
    component: () => import('@/components/views/services/emailLookup/EmailLookupNew.vue'),
    redirect: { name: EmailLookupRoutes.singleLookup },
    children: [
      {
        name: EmailLookupRoutes.singleLookup,
        path: '',
        component: () => import('@/components/views/services/emailLookup/EmailLookupSingle.vue'),
        props: { tab: true },
        meta: {
          tabTitle: 'pageTabTitle.user.services.emailLookup.singleLookup',
        },
      },
      {
        name: EmailLookupRoutes.bulkLookup,
        path: 'bulk-lookup',
        component: () => import('@/components/views/services/emailLookup/EmailLookupBulk.vue'),
        meta: {
          tabTitle: 'pageTabTitle.user.services.emailLookup.bulkLookup',
        },
      },
      {
        name: EmailLookupRoutes.history,
        path: 'history',
        component: () => import('@/components/views/services/emailLookup/EmailLookupHistory.vue'),
        props: { tab: true },
        meta: {
          tabTitle: 'pageTabTitle.user.services.emailLookup.history',
        },
      },
    ],
  },
  ...getEmailLookupDetailsRoutes(),
]
